module.exports = __webpack_public_path__ + "static/media/kathy_tran_manager1.888fad56.png";